import React from "react";
import CreateMaintenanceRequest from "../CreateMaintenanceRequest";

export default function OfficeMaintenanceCreateSection({
  onNotify,
  onRequestCreated,
  mastersFromParent = false,
  masters = null,
  mastersLoadError = "",
}) {
  return (
    <div
      id="mr-create"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">New request</h3>
        <p className="user-builder-panel__hint">Log a new maintenance request from this form.</p>
      </div>
      <CreateMaintenanceRequest
        mastersFromParent={mastersFromParent}
        masters={masters}
        mastersLoadError={mastersLoadError}
        onNotify={onNotify}
        onRequestCreated={onRequestCreated}
      />
    </div>
  );
}
